import type { GetBrandDTO } from "@nlc/shared-types";

import { BrandRequestsLayout } from "@/features/brands/edit/components/requests/BrandRequestsLayout";

type RequestsTabProps = {
  brand: Pick<GetBrandDTO, "id">;
};

export function RequestsTab({ brand }: RequestsTabProps) {
  return <BrandRequestsLayout brandId={brand.id} fullBleed={false} />;
}
